<div class="ui-g ui-fluid">
    <div class="ui-g-12" class="background">
      <div class="ui-g-12">
        <h2 class="title">Teléfonos importantes</h2>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
      <div class=" ui-g-12 ui-md-12 ui-lg-10">
        <div class="ui-g-12 ui-md-4 ui-lg-3">
          <div class="center">
            <img src="../../assets/images/important-phones/telefono.png" alt="" style="margin: 20% auto; width: 250px;">
          </div>
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-9">
          <div class="ui-g-12 ui-md-6 ui-lg-6" *ngFor="let importantPhone of importantPhonesUpdated; let i = index">
            <div *ngIf="i % 2 == 0" class="cardBlue ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/{{importantPhone.icon}}" alt="">
              </div>
              <div class="fondo">
                <h3>{{importantPhone.title}}</h3>
                <h2 class="subTitle">{{importantPhone.desc}}</h2>
                <h2 class="subTitle" style="visibility: hidden;">Voluntarios: 122</h2>
              </div>
            </div>

            <div *ngIf="i % 2 != 0" class="cardBlue3 ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/{{importantPhone.icon}}" alt="">
              </div>
              <div class="fondo">
                <h3>{{importantPhone.title}}</h3>
                <h2 class="subTitle">{{importantPhone.desc}}</h2>
                <h2 class="subTitle" style="visibility: hidden;">Voluntarios: 122</h2>
              </div>
            </div>
          </div>
<!--
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/bomberos.png" alt="">
              </div>
              <div class="fondo">
                <h3>Bomberos</h3>
                <h2 class="subTitle">Municipales: 123</h2>
                <h2 class="subTitle">Voluntarios: 122</h2>
              </div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue3 ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/police.png" alt="">
              </div>
              <div class="fondo">
                
                <h3>Policía Nacional</h3>
                <h2 class="subTitle">110</h2>
                <h2 class="subTitle" style="visibility: hidden;">Voluntarios: 122</h2>
                
              </div>
            </div>
          </div>
          
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/IGSS.png" alt="" >
              </div>
              <div class="fondo">
                <h3>IGGS</h3>
                <h2 class="subTitle">1522</h2>
              </div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue3 ui-g-12">
              <div class="center">
                <img class="margin" src="../../assets/images/important-phones/Tecniseguros.png" alt="" >
              </div>
              <div class="fondo">
                <h3 >Tecniseguros</h3>
                <h2 class="subTitle" >(502) 2300 6700</h2>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
    </div>
    
  </div>
  